var _path, _path2, _path3, _path4, _ellipse, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRoom(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1875 2.11138L2.11032 5.61959C2.04334 5.64868 2 5.71475 2 5.78779V15.0067C2 15.1409 2.13938 15.2296 2.26096 15.1729L6.37419 13.2522L10.3344 11.5089C10.401 11.4796 10.4439 11.4138 10.4439 11.3411V2.27957C10.4439 2.14754 10.3086 2.05878 10.1875 2.11138Z",
    stroke: "#848A9B",
    strokeWidth: 1.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7104 2C13.7348 3.41174 15.4461 4.21053 18.4396 5.60787C18.5045 5.63814 18.5467 5.70376 18.5463 5.77531L18.5052 14.5638C18.5046 14.694 18.3723 14.7821 18.252 14.7325L10.7104 11.6272",
    stroke: "#848A9B",
    strokeWidth: 1.1,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 15.2947L10.173 18.1982L18.5038 14.8363",
    stroke: "#848A9B",
    strokeWidth: 1.1,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5117 12.3973V6.98206L15.6273 8.40244V13.7585",
    stroke: "#848A9B",
    strokeWidth: 1.1
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.9579,
    cy: 10.8874,
    rx: 0.408272,
    ry: 0.272182,
    transform: "rotate(21.7622 14.9579 10.8874)",
    fill: "#848A9B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5625 11.4996C4.57548 10.3832 4.59366 8.07249 4.5625 7.76093L8.1065 6.20312V9.82501L4.5625 11.4996Z",
    stroke: "#848A9B",
    strokeWidth: 1.1
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoom);
export default __webpack_public_path__ + "static/media/room.b08d875354a7895463b016fb99d7965c.svg";
export { ForwardRef as ReactComponent };